import httpClient from "./httpClient";

const version = async (): Promise<string | undefined> => {
	const response = await httpClient.post(`/buildversion`);
	return response.data as string;
};

export { version };
